<template>
  <div id="newGoodMainPicture" class="good-main-picture">
    <div class="good-pic">
      <div>
        <div class="logo"><img :src="storeSign.logoUrl" alt=""/></div>
        <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/share_wxshopbg_1.png" alt="">
      </div>
    </div>
    <div class="good-info">
      <div class="qr-wrapper">
        <img v-if="canvasSrc" :src="canvasSrc" alt=""/>
      </div>
      <div class="title-line">
        <div class="name">{{ storeSign.o2oStoreName || storeSign.storeName }}</div>
        <div class="price">
          <p>扫一扫访问门店</p>
        </div>
      </div>
      
      <!-- <div class="share-name-line">
        <div v-if="isPartner"
             class="share-name">由{{ $store.state.userInfo.username }}分享</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import personalApi from '@/http/service/index'
import { getStoreSign } from '@/http/service/shop'
import html2canvas from 'html2canvas'
import { getClientSunCode } from '@/http/service/common'

export default {
  name: 'newShopMainPicture',
  data(){
    return {
      canvasSrc: '',
      storeSign: {},
    }
  },
  async mounted(){
    // this.$toast.loading({
    //   forbidClick: true,
    //   message: '加载中...',
    //   duration: 0
    // })
    await Promise.all([
      this.getShopInfo(),
      this.getInitQrCode()
    ]).then(()=>{
      console.log('all end==============>')
      this.$nextTick(async()=>{
        try {
          let imgUrl = await this._html2canvas()
          // this.$util.logColor('imgUrl', 'green', imgUrl)
          sessionStorage.setItem('sg_wxtlsharepic', imgUrl.split('base64,')[1])
          this.$emit('picFinish')
          this.$toast.clear()
        } catch (error) {
          this.$util.logColor('canvashtml', 'green', error)
          this.$toast.clear()
        }
      })
    }).catch(e=>{
      console.log('all catch')
      this.$toast.clear()
    })
  },
  computed: {
    ...mapGetters('mymanage', ['getCurrentRole']),
    ...mapGetters(['mId', 'accessToken']),
    location() {
      return this.$store.getters['getlocationInfo']
    },
  },
  methods: {
    getShopInfo() {
      const { storeId, mdCode } = this.$route.query
      return getStoreSign({
        storeId: storeId,
        latitude: this.location.latitude,
        longitude: this.location.longitude,
        shareId: sessionStorage.getItem('shareUserId') || '',
        mdCode: mdCode || ''
      }).then(res => {
        if (res.success) {
          this.storeSign = res.data;
          this.storeSign.o2oStoreName = res.data?.o2oStoreName.substring(0, 32)
          this.storeSign.storeName = res.data?.storeName.substring(0, 32)
          if (!res.data?.logoUrl) {
            this.storeSign.logoUrl = 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/default_shop_avator.png'
          }
        }
      }).catch(e => { console.log(e) })
    },

    queryParams(){
      const { storeId, mdCode } = this.$route.query
      const query = this.getCleanQuerys()
      query.storeId = storeId
      query.mdCode = mdCode
      if (this.mId) {
        query.shareId = this.mId
      }
      if (this.$util.isShopKeeper()) {
        query.open_source = 'haier-app-shopKeeper-shared'
      }
      if (this.getCurrentRole?.userIdentity) query.shareRole = this.getCurrentRole.userIdentity
      query.linkType = 'share'
      query.sharePlatform = 'WechatTimeLine'
      query.uid = localStorage.getItem('ucId')
      console.log('query===>', query)
      return query
    },

    async shareLinkFactoryUplus(){
      let query = this.queryParams()
      let params = {
        storeId: query.storeId,
        mdCode: query.mdCode,
      }
      if(query.shareId) {
        params.shareId = query.shareId
      }
      let queryString = new URLSearchParams(params).toString()

      const appInfo = await this.$util.getAppInfo()
      const { data } = await getClientSunCode({
        appId: "wxe24b2f1f4e378891", //智家APP小程序
        scene: queryString,
        page: 'subPageMall/templateIndex/templateIndex',
        envVersion: this.$util.isProdEnv() ? "release" : 'trial',
        // envVersion: 'release',
        qrWidth: 500
      }, {
        appId: appInfo?.appId || '',
        appVersion: appInfo?.appVersion || '',
        clientId: appInfo?.clientId || '',
        timestamp: new Date().getTime(),
        accountToken: this.accessToken
      })
      console.log('genreateQr========222=======>', data)
      if (data.retCode === '00000') {
        this.canvasSrc = data.data.data
        return data.data.data
      } else {
        this.$toast('获取信息码失败')
      }
    },
    async getInitQrCode(){
      if (this.$util.isUplus()) {
        return await this.shareLinkFactoryUplus()
      } else {
        return await this.getShopQrCode()
      }
    },
    getShopQrCode() {
      let query = this.queryParams()
      const params = {
        appid: this.$util.getQrAppid(),
        miniProgName: 'WX_PRIVATE',
        type: 'MINI_PROGRAM_CODE',
        contentUrl: this.$util.isShopKeeper() ? 'subPages/templateIndex/templateIndex' : '/subPageMall/templateIndex/templateIndex',
        extra: { 
          ...query,
          source_type: 'PYQ',
          source_code: this.$util.getBackEndChannelId(),
        },
        envVersion: this.$util.isProdEnv() ? 'RELEASE' : 'TRIAL',
        width: '400',
        hyaline: false,
        checkPath: this.$util.isProdEnv()
      }
      return personalApi.genreateQr(params).then(res => {
        console.log('genreateQr========111=======>', res.data)
        if(res?.data?.success) {
          this.canvasSrc = res?.data?.data?.fileLink
        } else {
          this.$toast('获取门店信息码失败')
        }
      }).catch(res => {
        this.$toast('请求失败，请重试')
      })
    },

    shareContent () {
      return document.getElementById(`newGoodMainPicture`)
    },
    _getPixelRatio(context) {
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1
      return (window.devicePixelRatio || 1) / backingStore
    },
    _html2canvas() {
      return new Promise((resolve, reject) => {
        // 创建一个新的canvas
        const _canvas = this.shareContent()
        this.$util.logColor('_canvas', 'blue', _canvas)
        // 此处用于解决截图不清晰问题，将生成的canvas放大，然后再填充到原有的容器中就会清晰
        const width = _canvas.offsetWidth
        const height = _canvas.offsetHeight
        const canvas2 = document.createElement('canvas')
        const ctx = canvas2.getContext('2d')
        const ratio = this._getPixelRatio(ctx)
        const scale = ratio
        canvas2.width = width * scale
        canvas2.height = height * scale
        ctx.scale(scale, scale)
        const opts = {
          scale: 1,
          canvas: canvas2,
          logging: true, // 日志开关，便于查看html2canvas的内部执行流程
          width,
          height,
          allowTaint: true, 
          useCORS: true, // 【重要】开启跨域配置
        }
        html2canvas(_canvas, opts).then(async canvas => {
          const context = canvas.getContext('2d')
          // 【重要】关闭抗锯齿
          context.mozImageSmoothingEnabled = false
          context.webkitImageSmoothingEnabled = false
          context.msImageSmoothingEnabled = false
          context.imageSmoothingEnabled = false

          const screenUrl = canvas.toDataURL('image/png')
          console.log('screenUrl', screenUrl)
          resolve(screenUrl)
        }).catch(e => { console.log(e) });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.good-main-picture {
  margin: 0 auto;
  width: 4.64rem;
  padding: .24rem 0;
  border-radius: 0.24rem;
  overflow: hidden;
  background-color: white;
}

.good-pic {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.16rem;
  height: 4.16rem;
  box-sizing: border-box;
  border-radius: .16rem;
  overflow: hidden;
  div{
    position: relative;
    width: 4.16rem;
    height: 4.16rem;
    background: #fff;
    overflow: hidden;
    .logo{
      position: absolute;
      left: .16rem;
      top: .16rem;
      width: .72rem;
      height: .72rem;
      border-radius: .7rem;
      overflow: hidden;
    }
    img{
      width: 100%;
      height: 100%;
    }
  }
}

.good-info {
  display: flex;
  padding: 0 .24rem;
  padding-top: .24rem;
  .title-line {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: .16rem;
    height: 1.48rem;
    .name {
      font-size: .26rem;
      line-height: .36rem;
      word-break: break-all;
      font-weight: 500;
      @include text-overflow(2);
      font-family: PingFangSC-Medium, "Microsoft YaHei";
    }

    .price {
      color: #ED2856;
      font-size: .24rem;
      font-family: "PingFang SC";
      .price-icon,
      .price-float {
        font-size: 0.24rem;
        font-weight: 500;
      }

      .price-int {
        font-size: 0.36rem;
        font-weight: 500;
      }

      .has-sub {
        font-size: 0.24rem;
        line-height: 0.24rem;
        font-weight: 500;
      }

      p{
        font-size: .2rem;
        color: #999;
      }
    }
  }

  .qr-wrapper {
    width: 1.48rem;
    height: 1.48rem;
    border-radius: .16rem;
    overflow: hidden;
    img{
      width: 1.48rem;
      height: 1.48rem;
      margin-right: 0.36rem;
    }
  }


  .share-name-line {
    margin-top: 0.25rem;
    padding: 0 0.53rem;

    .share-name {
      font-size: 0.22rem;
      text-align: center;
      color: #999999;
      line-height: 0.83rem;
      border-top: 0.02rem solid #dddddd;
    }
  }
}


.goods-rights {
  width: 100%;
  .rights-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #ffffff;
    border: 0.02rem solid #ffe3d9;
    border-radius: 0.12rem;
    margin: 0.02rem 0.36rem 0 0.34rem;
    .rights-title {
      margin: 0.1rem 0 0.08rem 0.12rem;
      img {
        width: 1.86rem;
        height: 0.32rem;
      }
    }
    .rights-main {
      margin-bottom: 0.12rem;
      .rights-text {
        span {
          margin: 0rem -0.38rem 0rem -0.38rem;
          display: block;
          font-size: 0.2rem;
          font-weight: 400;
          transform: scale(0.83);
          text-align: left;
          line-height: 0.28rem;
          color: #ff6026;
        }
      }
    }
  }
}
</style>